import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconEdit = memo(({ color = 'black', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        fillRule="evenodd"
        d="M2 17.885V22h4.115L18.25 9.865 14.135 5.75 2 17.885zM21.689 6.302a1.06 1.06 0 000-1.5l-2.49-2.49a1.059 1.059 0 00-1.501 0L15.75 4.258l3.991 3.991 1.948-1.948z"
      />
    </Svg>
  );
});
